import React from "react";
// import Header
import Header from "./components/Header";
import Home from "./pages/Home";
import IndexPage from "./pages/IndexPage";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Footer from "./components/Footer";
import ShowPage from "./pages/ShowPage";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import css
import "./App.css";

const App = () => {
  return(
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />}></Route>

        <Route path="/projects" element={<IndexPage label="Projects" />}></Route>
        <Route path="/articles" element={<IndexPage label="Articles" />}></Route>

        <Route path="/about-me" element={<About />}></Route>
        <Route path="/contact-me" element={<Contact />}></Route>

        <Route path={"/articles/:id"} element={<ShowPage />}></Route>
        <Route path={"/projects/:id"} element={<ShowPage />}></Route>

        <Route path="*" element={<Home />}></Route>
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
